import { useEffect, useState } from 'react'
import { useAuth } from '../auth/AuthProvider'
import { apiGet } from '../api/client'
import Layout from '../components/Layout'

type Customer = {
  id: string
  first_name: string
  last_name: string
  email: string | null
  phone_number: string | null
}

const thStyle: React.CSSProperties = {
  textAlign: 'left',
  borderBottom: '1px solid #e5e7eb',
  padding: '0.625rem 0.75rem',
  fontSize: '0.8rem',
  fontWeight: 600,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
}

const tdStyle: React.CSSProperties = {
  padding: '0.75rem',
  borderBottom: '1px solid #f3f4f6',
  fontSize: '0.9rem',
  color: '#111827',
}

export default function ClientsPage() {
  const { token } = useAuth()
  const [customers, setCustomers] = useState<Customer[]>([])
  const [fetchError, setFetchError] = useState<string | null>(null)
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    if (!token) return
    setIsFetching(true)
    apiGet<{ customers: Customer[] }>('/api/v1/customers', token)
      .then(({ customers }) => setCustomers(customers))
      .catch((err: unknown) => {
        setFetchError(err instanceof Error ? err.message : 'Unknown error')
      })
      .finally(() => setIsFetching(false))
  }, [token])

  return (
    <Layout>
      <h2 style={{ marginTop: 0, color: '#111827' }}>Clients</h2>

      {isFetching && <p style={{ color: '#6b7280' }}>Loading…</p>}
      {fetchError && <p style={{ color: '#dc2626' }}>Error: {fetchError}</p>}
      {!isFetching && customers.length === 0 && !fetchError && (
        <p style={{ color: '#6b7280' }}>No clients found for your firm.</p>
      )}

      {customers.length > 0 && (
        <div style={{ background: '#fff', borderRadius: '0.5rem', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead style={{ background: '#f9fafb' }}>
              <tr>
                {['Name', 'Email', 'Phone'].map((h) => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id}>
                  <td style={tdStyle}>{c.first_name} {c.last_name}</td>
                  <td style={{ ...tdStyle, color: '#6b7280' }}>{c.email ?? '—'}</td>
                  <td style={{ ...tdStyle, color: '#6b7280' }}>{c.phone_number ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  )
}
